import { IState } from '../store';
import { ISeoLinks } from '../store/seo_links';

export const seoLinksSelector = (state: IState): ISeoLinks | null => state.seoLinks.seoLinks;
